import { render, staticRenderFns } from "./SaturdayShifts.vue?vue&type=template&id=677f13cc&"
import script from "./SaturdayShifts.vue?vue&type=script&lang=js&"
export * from "./SaturdayShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports